/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

class PalleteColorAPI {
  constructor(){
    this.api_key = '37e08a939d0491e1a903';
    this.url = null;
    this.colorPaletteSelector = document.querySelector('.product-form__meta-color-pallete');
    this.codePaletteSelector = document.querySelector('.product-form__meta-color-pallete-code');
    this.palette_code = null;
    this.colorPaletteThumbnails = document.querySelector('.color-list li');
    this.parentWrapper = null;
    this.parentDivBlock = null;
    this.blockCard = null;
    this.init();
  }
  init(){
    if(this.codePaletteSelector){
      
      this.allAPIData().then(data => {
        console.log('Data in fetchData:', data);
        const options = this.codePaletteSelector.options;
        for (let i = 0; i < options.length; i++) {
          data.data.forEach(data => {
            data.palettes.forEach(palettes => {
              if(palettes.code == options[i].text){
                options[i].text = palettes.name.replace(/&reg;/g, "")+" ("+palettes.code+")"; 
              }
            });
          });
          
        }
       })
       .catch(error => {
         console.error('Error in fetchData:', error);
       });
    }
    
    if (this.colorPaletteSelector) {
      this.parentWrapper = this.colorPaletteSelector.closest('.product-block-list__wrapper');
      this.parentDivBlock = this.colorPaletteSelector.closest('.product-block-list__item');
      this.blockCard = this.colorPaletteSelector.closest('.product-block-list__item .card');
      //this.colorPaletteSelector.getAttribute('data-code');
      this.palette_code = this.codePaletteSelector.value;
      if (this.palette_code) {
          this.callAjaxColorPalette(this.palette_code)
      } 
      this.addEventListeners();
    }  
    
  }
  addEventListeners(){
    this.colorPaletteThumbnails = document.querySelectorAll('.product-form__meta-color-thumbnail');
    
    this.colorPaletteThumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => {
        this.updateColorPaletteSelector(thumb);
      });
    });

    this.codePaletteSelector.addEventListener('change', (event) => {
      this.palette_code = event.target.value;
      if(this.parentWrapper.querySelector('.color-list') || this.parentWrapper.querySelector('.so-accordion-wrapper')){
        this.parentWrapper.querySelector('.color-list').remove();
        this.parentWrapper.querySelector('.so-accordion-wrapper').remove();
      }
      this.callAjaxColorPalette(event.target.value);
    });
  }
  allAPIData() {
      const url = `https://api.benjaminmoore.com/api/${this.api_key}/color/GetPalettes?colorData=true&countryCode=en-ca`;
      console.log('Request URL:', url);
  
      // Return the promise from loadPalettefetchJSONP
      return this.loadPalettefetchJSONP(url, 'CallbackAPIFunction', (error) => {
          console.error('Error:', error);
      })
      .then(data => {
          return data; // Return the data
      })
      .catch(error => {
          console.error('Promise error:', error);
          throw error; // Re-throw the error for the caller to handle
      });
  }

  callAjaxColorPalette(palette_code){ 
          this.url = "//api.benjaminmoore.com/api/"+this.api_key+"/color/GetPaletteByCode?code="+palette_code+"&colorData=true&countryCode=en-us";
          
          this.loadPalettefetchJSONP(this.url, 'CallbackFunction', function(error) {
              console.error('Error:', error);
          }).then(data => {
              console.log('Data:', data);
              this.populateColorOptions(data);
          });
  }
  updateColorPaletteSelector(thumb){ 
    if (this.colorPaletteSelector) {
      this.colorPaletteSelector.value = thumb.getAttribute('data-value'); 
      const event = new Event('change', { bubbles: true });
      this.colorPaletteSelector.dispatchEvent(event);
      document.querySelectorAll('.product-form__meta-color-thumbnail').forEach(thumbnail => {
        thumbnail.classList.remove('active');
      });
      thumb.classList.add('active');
    }
  }
  showModal(color) { 
    const modal = document.getElementById('color-modal');
    const modalBody = document.getElementById('modal-body');
    
    // Populate the modal with color details
    modalBody.innerHTML = `
      <h2>${color.name}</h2>
      <p>Color Number: ${color.number}</p>
      <p>Hex: #${color.hex}</p>
      <p>Description: ${color.description || 'No description available.'}</p>
    `;
    modal.querySelector('.modal-content').style.background = `#${color.hex}`;
    // Show the modal
    modal.style.display = 'block';

    // Add event listener to close the modal
    document.querySelector('.close').onclick = () => {
      modal.style.display = 'none';
    };

    // Close the modal when clicking outside of it
    window.onclick = (event) => {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    };
  }
  loadPalettefetchJSONP(url, callbackName, errorCallback) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const callback = `${callbackName}_${Date.now()}`;

      window[callback] = function(data) {
        resolve(data);
        document.body.removeChild(script);
        delete window[callback];
      };

      script.onerror = function() {
        reject(new Error('JSONP request failed'));
        document.body.removeChild(script);
        delete window[callback];
      };

      script.src = `${url}&callback=${callback}`;
      document.body.appendChild(script);
    }).catch(errorCallback);
  }
  populateColorOptions(api) {
    if (api && api.data) {
      this.colorPaletteSelector.innerHTML = ''; // Clear existing options
      const thumbnails = document.createElement('ul');
      thumbnails.style.listStyleType = 'none';
      thumbnails.className = 'color-list';
      let accordion_wrapper = document.createElement('div');
      accordion_wrapper.className = "so-accordion-wrapper";
      let so_tab_div = document.createElement('div');
      so_tab_div.className = "so-tab";

      let pallete_checkbox = document.createElement('input');
      pallete_checkbox.setAttribute("type", "checkbox");
      pallete_checkbox.setAttribute("name", "tabs");
      pallete_checkbox.setAttribute("id", this.palette_code);
      pallete_checkbox.setAttribute("checked", true);
            
      let pallete_label = document.createElement('label');
      pallete_label.textContent = api.data.name.replace(/&reg;/g, "");;
      pallete_label.setAttribute("for", this.palette_code);
            
      let pallete_content_div = document.createElement('div');
      pallete_content_div.classList.add('so-tab-content');
      pallete_content_div.innerHTML = api.data.description;
      
      api.data.colors.forEach(color => {
        const option = document.createElement('option');
        option.value = color.name +" ("+color.number+")";
        option.textContent = color.name +" ("+color.number+")";
        
        const thumbnail_item = document.createElement('li');
        thumbnail_item.setAttribute('data-value', color.name +" ("+color.number+")");
        thumbnail_item.textContent = color.name +" ("+color.number+")";
        thumbnail_item.style.background = "#"+color.hex;
        thumbnail_item.className = 'product-form__meta-color-thumbnail';
        thumbnail_item.addEventListener('click', thumb => {
          this.updateColorPaletteSelector(thumbnail_item);
          this.showModal(color);
        });
        
        this.colorPaletteSelector.appendChild(option);
        thumbnails.appendChild(thumbnail_item);
        
      });
      pallete_content_div.appendChild(thumbnails);
      so_tab_div.appendChild(pallete_checkbox);
      so_tab_div.appendChild(pallete_label);
      so_tab_div.appendChild(pallete_content_div);
      accordion_wrapper.appendChild(so_tab_div);
      this.colorPaletteSelector.parentNode.insertBefore(accordion_wrapper, this.colorPaletteSelector.nextSibling);
      this.adjustMinHeightIfOverflowing(this.parentDivBlock);
      
    } else {
      console.error('No colors found in the response.');
      this.colorPaletteSelector.innerHTML = ''; // Clear existing options
    }
  }
  adjustMinHeightIfOverflowing(parent){
      const lastChild = parent.lastElementChild;
      if (lastChild) {
          const parentRect = parent.getBoundingClientRect();
          const childRect = lastChild.getBoundingClientRect();
          
          // Check if the last child element is overflowing the parent element
          if (childRect.bottom > parentRect.bottom) {
              // Calculate the new min-height
              const newMinHeight = childRect.bottom - parentRect.top;
              this.parentWrapper.style.minHeight = `${newMinHeight}px`;
              console.log(`Adjusted min-height to ${newMinHeight}px`);
          } else {
              console.log('No overflow detected.');
          }
      }
  }
}

class ColourPalettePage {
  constructor() {
    this.api_key = '37e08a939d0491e1a903';
    this.url = null;
    this.parentContainer = document.querySelector('#colour-palette-snippet');
    this.init();
  }
  
  init() {
    if (this.parentContainer) {
      this.url = `https://api.benjaminmoore.com/api/${this.api_key}/color/GetPalettes?colorData=true&countryCode=en-ca`;
      console.log('Request URL:', this.url);

      this.loadPalettefetchJSONP(this.url, 'CallbackFunction', (error) => {
        console.error('Error:', error);
      }).then(data => {
        console.log('Data received:', data);
        this.populateColorOptions(data);
      }).catch(error => {
        console.error('Promise error:', error);
      });

      this.addEventListeners();
    }
  }
  loadCurrentColourPalette(colors){
    
      const thumbnails = document.createElement('ul');
      thumbnails.style.listStyleType = 'none';
      thumbnails.className = 'color-list';
      colors.forEach(color => {
        const thumbnail_item = document.createElement('li');
        thumbnail_item.setAttribute('data-value', color.name +" ("+color.number+")");
        thumbnail_item.textContent = color.name +" ("+color.number+")";
        thumbnail_item.style.background = "#"+color.hex;
        thumbnail_item.className = 'product-form__meta-color-thumbnail';
        thumbnail_item.addEventListener('click', () => this.showModal(color));
        thumbnails.appendChild(thumbnail_item);
      });
      return thumbnails;
  }
  populateColorOptions(api) {
    // Implement logic to populate color options in the select element
    
    if(api && api.data){
      api.data.forEach(data => {
        let parent_wrapper = document.createElement('div');
        parent_wrapper.classList.add('data-container');
        let parent_label = document.createElement('label');
        let accordion_wrapper = document.createElement('div');
        accordion_wrapper.className = "so-accordion-wrapper";
        
        parent_label.textContent = data.name;  
        parent_wrapper.appendChild(parent_label);
          data.palettes.forEach((palette, index) => {
            let so_tab_div = document.createElement('div');
            so_tab_div.className = "so-tab";
            
            let pallete_checkbox = document.createElement('input');
            pallete_checkbox.setAttribute("type", "checkbox");
            pallete_checkbox.setAttribute("name", "tabs");
            pallete_checkbox.setAttribute("id", palette.code+"-"+index);
            
            let pallete_label = document.createElement('label');
            pallete_label.textContent = palette.name.replace(/&reg;/g, "");
            pallete_label.setAttribute("for", palette.code+"-"+index);
            
            let pallete_content_div = document.createElement('div');
            let enlarge_btn = document.createElement('p');
            enlarge_btn.textContent = "Click on colour to see larger version";
            enlarge_btn.classList.add('enlarge');
            enlarge_btn.addEventListener('click', () => {
              //this.showModal(palette.colors);
            });
            
            let buy_btn = document.createElement('button');
            buy_btn.textContent = "Buy now";
            buy_btn.classList.add('buy-now','tab-buttons');
            buy_btn.addEventListener('click', function(){
              //let buy_link = "//api.benjaminmoore.com/api/"+this.api_key+"/color/GetPaletteByCode?code="+palette.code+"&colorData=true&countryCode=en-us";
              //window.open("/"+palette.code, "_blank");
              window.open("/collections/benjamin-moore-choose-your-finish", "_blank");
            });
            
            pallete_content_div.classList.add('so-tab-content');
            pallete_content_div.innerHTML = palette.description;
            pallete_content_div.appendChild(enlarge_btn);
            pallete_content_div.appendChild(buy_btn);
            pallete_content_div.appendChild(this.loadCurrentColourPalette(palette.colors));
            
            so_tab_div.appendChild(pallete_checkbox);
            so_tab_div.appendChild(pallete_label);
            so_tab_div.appendChild(pallete_content_div);
            accordion_wrapper.appendChild(so_tab_div);
          });
        parent_wrapper.appendChild(accordion_wrapper);
        this.parentContainer.appendChild(parent_wrapper);
      });
      
    }
  }
  showModal(color) { 
    const modal = document.getElementById('color-modal');
    const modalBody = document.getElementById('modal-body');
    
    // Populate the modal with color details
    modalBody.innerHTML = `
      <h2>${color.name}</h2>
      <p>Color Number: ${color.number}</p>
      <p>Hex: #${color.hex}</p>
      <p>Description: ${color.description || 'No description available.'}</p>
    `;
    modal.querySelector('.modal-content').style.background = `#${color.hex}`;
    // Show the modal
    modal.style.display = 'block';

    // Add event listener to close the modal
    document.querySelector('.close').onclick = () => {
      modal.style.display = 'none';
    };

    // Close the modal when clicking outside of it
    window.onclick = (event) => {
      if (event.target === modal) {
        modal.style.display = 'none';
      }
    };
  }
  addEventListeners() {
    // Add any required event listeners
  }

  loadPalettefetchJSONP(url, callbackName, errorCallback) {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const callback = `jsonp_callback_${Date.now()}`;
      const fullUrl = `${url}&callback=${callback}`;
      
      // Create a global callback function
      window[callback] = function(data) {
        resolve(data);
        document.body.removeChild(script);
        delete window[callback];
      };

      // Handle script loading errors
      script.onerror = function() {
        reject(new Error('JSONP request failed'));
        document.body.removeChild(script);
        delete window[callback];
      };

      script.src = fullUrl;
      document.body.appendChild(script);

      console.log('Script created:', script.src);
    }).catch(errorCallback);
  }
}


// Add an event listener to execute the function when DOM content is loaded
document.addEventListener('DOMContentLoaded', () => {
  new PalleteColorAPI();
  new ColourPalettePage();
});

/* --------------------------------------------------------------
   DECOR EXPRESS
   FILTER SIZE OPTIONS BY SELECTED FINISH

   Warehouse theme:
   - uses label title as real option value
   - hides combinations that DO NOT EXIST
   - keeps existing out-of-stock variants visible
-------------------------------------------------------------- */

(function () {

  function startFinishSizeFilter() {

    var form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('.product-form');

    if (!form) {
      console.log('Finish/Size Filter: product form not found');
      return;
    }


    /* Get real Shopify variants */

    var productUrl =
      window.location.pathname.replace(/\/$/, '') + '.js';


    fetch(productUrl)
      .then(function (response) {

        if (!response.ok) {
          throw new Error('Could not load product JSON');
        }

        return response.json();

      })

      .then(function (product) {

        if (!product || !product.options || !product.variants) {
          return;
        }


        /* ---------------------------------------------
           Find Finish and Size positions
        --------------------------------------------- */

        var optionNames = product.options.map(function (option) {

          if (typeof option === 'string') {
            return option;
          }

          return option.name;

        });


        var finishIndex = optionNames.findIndex(function (name) {

          return (
            name &&
            name.toLowerCase().trim() === 'finish'
          );

        });


        var sizeIndex = optionNames.findIndex(function (name) {

          return (
            name &&
            name.toLowerCase().trim() === 'size'
          );

        });


        if (finishIndex === -1 || sizeIndex === -1) {

          console.log(
            'Finish/Size Filter: Finish or Size option not found',
            optionNames
          );

          return;

        }


        /*
          Shopify positions start from 1.

          Example:
          Finish = option1
          Size   = option2
        */

        var finishPosition = finishIndex + 1;
        var sizePosition = sizeIndex + 1;



        /* ---------------------------------------------
           Get Warehouse swatches
        --------------------------------------------- */

        function getFinishInputs() {

          return Array.from(
            form.querySelectorAll(
              '.product-form__single-selector[data-option-position="' +
              finishPosition +
              '"]'
            )
          );

        }


        function getSizeInputs() {

          return Array.from(
            form.querySelectorAll(
              '.product-form__single-selector[data-option-position="' +
              sizePosition +
              '"]'
            )
          );

        }



        /* ---------------------------------------------
           IMPORTANT:
           Warehouse input.value contains an ID.

           Real option value is stored on:
           label title="60ml"
        --------------------------------------------- */

        function getRealOptionValue(input) {

          if (!input || !input.id) {
            return null;
          }


          var label = form.querySelector(
            'label[for="' +
            CSS.escape(input.id) +
            '"]'
          );


          if (!label) {
            return null;
          }


          var value =
            label.getAttribute('title') ||
            label.textContent;


          return value
            ? value.trim()
            : null;

        }



        /* ---------------------------------------------
           Currently selected Finish
        --------------------------------------------- */

        function getSelectedFinish() {

          var checked = getFinishInputs().find(function (input) {
            return input.checked;
          });


          if (!checked) {
            return null;
          }


          return getRealOptionValue(checked);

        }



        /* ---------------------------------------------
           Read Shopify variant option
        --------------------------------------------- */

        function getVariantOption(variant, index) {

          if (
            Array.isArray(variant.options) &&
            variant.options[index] !== undefined
          ) {

            return variant.options[index];

          }


          var property =
            'option' + (index + 1);


          return variant[property];

        }



        /* ---------------------------------------------
           Does Finish + Size EXIST?

           Inventory is deliberately NOT checked here.
           Therefore out-of-stock variants stay visible.
        --------------------------------------------- */

        function combinationExists(finish, size) {

          return product.variants.some(function (variant) {

            return (
              getVariantOption(
                variant,
                finishIndex
              ) === finish
              &&
              getVariantOption(
                variant,
                sizeIndex
              ) === size
            );

          });

        }



        /* ---------------------------------------------
           Is the existing combination available?

           Used ONLY when choosing the next size
           automatically.
        --------------------------------------------- */

        function combinationAvailable(finish, size) {

          return product.variants.some(function (variant) {

            return (
              getVariantOption(
                variant,
                finishIndex
              ) === finish
              &&
              getVariantOption(
                variant,
                sizeIndex
              ) === size
              &&
              variant.available === true
            );

          });

        }



        /* ---------------------------------------------
           Hide / show sizes
        --------------------------------------------- */

        function updateSizes() {

          var selectedFinish =
            getSelectedFinish();


          if (!selectedFinish) {
            return;
          }


          var sizeInputs =
            getSizeInputs();


          if (!sizeInputs.length) {
            return;
          }


          sizeInputs.forEach(function (input) {

            var size =
              getRealOptionValue(input);


            if (!size) {
              return;
            }


            var exists =
              combinationExists(
                selectedFinish,
                size
              );


            /*
              Screenshot confirmed that each option
              is wrapped in .block-swatch
            */

            var wrapper =
              input.closest('.block-swatch');


            if (wrapper) {

              if (exists) {

                wrapper.style.display = '';

              } else {

                wrapper.style.display = 'none';

              }

            }

          });



          /* ------------------------------------------
             If currently selected size has just
             disappeared, select another valid size.
          ------------------------------------------ */

          var selectedSizeInput =
            sizeInputs.find(function (input) {
              return input.checked;
            });


          if (!selectedSizeInput) {
            return;
          }


          var selectedSize =
            getRealOptionValue(
              selectedSizeInput
            );


          if (
            combinationExists(
              selectedFinish,
              selectedSize
            )
          ) {

            return;

          }



          /*
            First preference:
            existing AND in-stock size.
          */

          var replacement =
            sizeInputs.find(function (input) {

              var size =
                getRealOptionValue(input);


              return (
                combinationExists(
                  selectedFinish,
                  size
                )
                &&
                combinationAvailable(
                  selectedFinish,
                  size
                )
              );

            });



          /*
            If every valid size is out of stock,
            still select the first EXISTING one.
          */

          if (!replacement) {

            replacement =
              sizeInputs.find(function (input) {

                var size =
                  getRealOptionValue(input);


                return combinationExists(
                  selectedFinish,
                  size
                );

              });

          }



          if (replacement) {

            var replacementLabel =
              form.querySelector(
                'label[for="' +
                CSS.escape(replacement.id) +
                '"]'
              );


            if (replacementLabel) {

              replacementLabel.click();

            } else {

              replacement.click();

            }

          }

        }



        /* ---------------------------------------------
           Finish changed
        --------------------------------------------- */

        getFinishInputs().forEach(function (input) {

          input.addEventListener(
            'change',
            function () {

              setTimeout(
                updateSizes,
                20
              );

            }
          );

        });



        /* ---------------------------------------------
           Warehouse native variant event

           Your custom.js confirms this event exists:
           variant:changed
        --------------------------------------------- */

        document.addEventListener(
          'variant:changed',
          function () {

            setTimeout(
              updateSizes,
              20
            );

          }
        );



        /* Initial load */

        setTimeout(
          updateSizes,
          50
        );


        console.log(
          'Finish/Size Filter loaded',
          {
            finishPosition: finishPosition,
            sizePosition: sizePosition
          }
        );

      })

      .catch(function (error) {

        console.error(
          'Finish/Size Filter error:',
          error
        );

      });

  }



  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      startFinishSizeFilter
    );

  } else {

    startFinishSizeFilter();

  }

})();

/* ==============================================================
   DECOR EXPRESS - PAINT CART CROSS-SELL
   Handles size selection and one-click add from the cart cross-sell.
============================================================== */
(function () {
  if (window.__decorPaintCartCrossSellBound) {
    return;
  }

  window.__decorPaintCartCrossSellBound = true;

  document.addEventListener('change', function (event) {
    var select = event.target.closest('.paint-cart-cross-sell__variant-select');

    if (!select) {
      return;
    }

    var item = select.closest('.paint-cart-cross-sell__item');
    var button = item ? item.querySelector('.paint-cart-cross-sell__add') : null;
    var price = item ? item.querySelector('[data-cross-sell-price]') : null;
    var option = select.options[select.selectedIndex];

    if (button && select.value) {
      button.setAttribute('data-variant-id', select.value);
    }

    if (price && option && option.getAttribute('data-price')) {
      price.textContent = option.getAttribute('data-price');
    }
  });

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('.paint-cart-cross-sell__add');

    if (!button) {
      return;
    }

    event.preventDefault();

    if (button.disabled) {
      return;
    }

    var item = button.closest('.paint-cart-cross-sell__item');
    var select = item ? item.querySelector('.paint-cart-cross-sell__variant-select') : null;
    var variantId = select && select.value
      ? select.value
      : button.getAttribute('data-variant-id');

    if (!variantId) {
      return;
    }

    var originalText = button.textContent;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root
      : '/';

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = 'Adding...';

    try {
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: Number(variantId),
            quantity: 1
          }]
        })
      });

      if (!response.ok) {
        throw new Error('Could not add cross-sell product to cart');
      }

      await response.json();

      button.textContent = 'Added ✓';
      button.removeAttribute('aria-busy');

      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          quantity: 1
        }
      }));
    } catch (error) {
      console.error('Paint cart cross-sell:', error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = 'Try again';

      window.setTimeout(function () {
        if (!button.disabled) {
          button.textContent = originalText;
        }
      }, 1800);
    }
  });
})();
